import { orderBy } from 'lodash';
import { createSelector } from 'reselect';
import { RootState } from '../root.reducer';

export const selectProjects = createSelector(
    (state: RootState) => Object.values(state.projects),
    (projects: any) => orderBy(projects, 'name')
)
